import { useNavigation, useRoute } from "@react-navigation/native";
import React, {useEffect, useState} from "react";
import {
  Dimensions,
  Modal,
  StyleSheet,
  TouchableOpacity,
  Text,
  View,
} from "react-native";
import { Color, globalFontStyle, globalStyle } from "../../../assets";
import Width from "../../../assets/Width";
import { Button } from "../../../components/core/Button";
import LottieComp from "../../../commonComponents/Lottie";
import { navigationReset } from "../../../navigation/rootNavigation";
import { cross_new, tick_new } from "../../../utils/images";
import MergeShareSuccess from "../../portfolio/childComponents/mergeShareSuccess";
import LiquidityStatus from "./LiquidityStatus";
import Colors from "../../../assets/Color/Colors";
import { trackMoengageEvent, isMobile } from "../../../utils/commonMethods";
import FastImage from "../../../common/FastImage";
import {globalConfigurableData, globalConst, GlobalScreens} from "../../../utils/globalConstant";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import CoinsBottomSheet from "../../home/childComponents/CoinsBottomSheet";

const Error = ({ orderData, onDoneClick }) => {
  const nav = useNavigation();
  let message = orderData?.data?.error;
  let insufficientFund = orderData?.required;
  if (insufficientFund) {
    trackMoengageEvent("Add funds - Insufficient Funds");
  }
  let isClosedMarket = orderData?.closedMarket;
  let buttonText = isClosedMarket ? "See Similar markets" : "Retry";
  const handleActions = () => {
    if (insufficientFund) {
      if (isMobile()) {
        nav.push("WalletStack", {
          screen: "WalletAdd",
          params: { rechargeAmount: insufficientFund.toString() },
        });
      } else {
        nav.navigate("Wallet", { rechargeAmount: insufficientFund.toString() });
      }
      trackMoengageEvent("Click on wallet", {
        "Referral Screen": "Event Page",
      });

      onDoneClick();
    } else if (isClosedMarket) {
      onDoneClick();
      isMobile() &&
        setTimeout(() => {
          navigationReset();
        }, 400);
    } else {
      onDoneClick();
    }
  };

  return (
    <View style={{ flex: 1 }}>
      <FastImage
        style={{ width: 60, height: 60, alignSelf: "center", marginBottom: 20 }}
        source={globalConfigurableData?.cross_new()}
      ></FastImage>

      <FormTextLabel
        labelStyles={[styles.orderStatusText, { color: globalConfigurableData.primaryTextColor1 }]}
        label={"Order Not Executed"}
      />
      <FormTextLabel
        labelStyles={[styles.failedOrderText]}
        label={
          typeof orderData?.message === "string" && orderData?.message
            ? orderData?.message
            : "Something Went Wrong"
        }
      />

      <FormTextLabel labelStyles={[styles.failedOrderText]} label={message} />
      <View style={[globalStyle.customBtnParentModalStyle]}>
        {orderData?.required ? (
          <Button
            variant="primary"
            onPress={() => {
              if (typeof handleActions === 'function') {
                handleActions();
              }
            }}
            style={{
              backgroundColor: Colors.black,
            }}
            translate
          >
            {`Add  ${insufficientFund}`}
          </Button>
        ) : (
          <Button
            variant="primary"
            onPress={() => {
              if (typeof handleActions === 'function') {
                handleActions();
              }
            }}
            style={{
              backgroundColor: Colors.black,
            }}
            translate
          >
            {buttonText}
          </Button>
        )}
      </View>
    </View>
  );
};

const TradeStatus = ({ onDoneClick, apiRespnseUiData,}) => {
  let route = useRoute();
  const contestId = route?.params?.contestId;
  let orderData = apiRespnseUiData?.orderData;
  let respData = orderData?.data?.respData
    ? orderData?.data?.respData
    : orderData?.respData;
  if (orderData?.data) orderData = orderData.data;
  let calls = orderData?.calls;
  let index = 0;
  let success = orderData?.success;
  let navigation = useNavigation();
  const info = respData?.info;
  const [showPromo, setShowPromo] = useState(false);
  const getStartEnd = (str, sub) => [
    str.indexOf(sub),
    str.indexOf(sub) + sub.length - 1,
  ];

  const handleActions = () => {
    if (respData?.show_promo_message) {
      setShowPromo(true);
    } else {
      onDoneClick();
    }
  };

  var indexText = [0, 0];
  if (info) {
    indexText = getStartEnd(info, "Portfolio");
  }
  if (orderData?.status === "ERROR" || orderData?.status === "failed") {
    success = false;
  }
  /*if (apiRespnseUiData.removeLiquidity && success) {
    return (
      <LiquiditySuccess
        orderData={orderData}
        onDoneClick={onDoneClick}
        isRemoveLiquidity={true}
      />
    );
  }
  if (apiRespnseUiData.isMergeShare && success) {
    return (
      <MergeShareSuccess orderData={orderData} onDoneClick={onDoneClick} />
    );
  }


  }*/
  if (apiRespnseUiData.isMergeShare && success) {
    return (
      <MergeShareSuccess orderData={orderData} onDoneClick={onDoneClick} />
    );
  }
  if (apiRespnseUiData.showLiquidity && success) {
    return (
      <LiquidityStatus
        orderData={orderData}
        onDoneClick={onDoneClick}
        isRemoveLiquidity={false}
      />
    );
  }
  if (apiRespnseUiData?.removeLiquidity && success) {
    return (
      <LiquidityStatus onDoneClick={onDoneClick} isRemoveLiquidity={true} />
    );
  }
  const tradeType = orderData?.call?.tradeType;
  const callvalue = orderData?.call?.callvalue;
  let latest_date;
  if (success && calls && calls.length >= 0) {
    for (let i = 0; i < calls.length; i++) {
      if (
        (tradeType === "Sell" &&
          (calls[i].status === "EX" || calls[i].status === "H")) ||
        (tradeType === "Buy" && calls[i].status === "A")
      ) {
        if (!latest_date || calls[i].createdat > latest_date) {
          index = i;
          latest_date = calls[i].createdat;
        }
      }
    }
    calls = calls[index];
  }

  const confirmShares = orderData?.matched || 0;
  const unmatchedShares = orderData?.unmatched || 0;
  const sharePrice = calls?.coins;
  const tradeAmount =
    tradeType === "Sell"
      ? confirmShares * sharePrice
      : (confirmShares + unmatchedShares) * sharePrice;

  const partiallyExecuted = orderData?.msg && orderData?.partiallyExecuted;

  return (
      <>
        {(showPromo && isMobile()) ? (
          <View
            style={{ width: Width.width, }}
          >
            <CoinsBottomSheet
              onBottomSheetClose={onDoneClick}
              promoData={respData?.promo_message}
              isSignUP={false}
            />
          </View>
        ) : (
          <View style={{ flex: 1, padding: 10, paddingHorizontal: 15 }}>
            <View
              style={{
                width: isMobile() ? Width.width - 30 : "auto",
                flex: 1,
                paddingTop: isMobile() ? 0 : 30,
              }}
            >
              {!success ? (
                <Error orderData={orderData} onDoneClick={onDoneClick} />
              ) : (
                <>
                  <FastImage
                    style={{
                      width: 60,
                      height: 60,
                      alignSelf: "center",
                      marginBottom: 20,
                    }}
                    source={globalConfigurableData?.tick_new()}
                  ></FastImage>

                  <Text style={[styles.orderStatusText]}>{respData?.title}</Text>

                  {(tradeType || apiRespnseUiData?.isPowerTrade) ? (
                    <View style={styles.tableContainer}>
                      {respData?.metadata?.map((item, index) => {
                        return (
                          <View
                            key={`metadata-${index}`}
                            style={[
                              styles.tableRow,
                              index === respData?.metadata?.length - 1
                                ? { borderBottomWidth: 0 }
                                : null,
                            ]}
                          >
                            <Text
                              style={{
                                ...styles.textFontStyle,
                                color: globalConfigurableData.secondaryTextColor1,
                              }}
                            >
                              {item.key}
                            </Text>
                            <Text style={styles.textFontStyle}>{item.value}</Text>
                          </View>
                        );
                      })}
                    </View>
                  ) : null}
                  {respData?.info ? (
                    <Text style={styles.failedOrderText}>
                      <Text
                        style={{
                          color: globalConfigurableData.secondaryTextColor1,
                        }}
                      >
                        {info.substring(0, indexText[0])}
                      </Text>
                      <Text
                        onPress={() => {
                          if (respData?.redirect === "Portfolio") {
                            onDoneClick();
                            if (contestId) {
                              navigation.navigate("ContestPortfolio", {
                                contestId: contestId,
                                tab: true,
                                merge: true,
                              });
                            } else {
                              navigation.navigate("Portfolio");
                            }
                          }
                        }}
                        style={
                          respData?.redirect === "Portfolio"
                            ? {
                                color: GlobalScreens.SingleOrder.highlightColor,
                                textDecorationLine: "underline",
                              }
                            : {
                                color: globalConfigurableData.secondaryTextColor1,
                              }
                        }
                      >
                        {info.substring(indexText[0], indexText[1] + 1)}
                      </Text>
                      <Text
                        style={{
                          color: globalConfigurableData.secondaryTextColor1,
                        }}
                      >
                        {info.substring(indexText[1] + 1, info.length)}
                      </Text>
                    </Text>
                  ) : null}
                  <View style={[globalStyle.customBtnParentModalStyle]}>
                    <Button
                      variant="primary"
                      onPress={() => {
                        if (typeof handleActions === 'function') {
                          setTimeout(() => {
                            handleActions();
                          }, globalConst.buttonTimer);
                        }
                      }}
                      style={{
                        backgroundColor: callvalue === 'Y' ? Colors.yesColor : 
                          callvalue === 'N' ? Colors.noColor : Colors.black,
                      }}
                      translate
                    >
                      Done
                    </Button>
                  </View>
                </>
              )}
            </View>
          </View>
        )}
      </>
  );
};

export default TradeStatus;

const styles = StyleSheet.create({
  orderStatusText: {
    ...globalFontStyle.appFontTitle,
    alignSelf: "center",
    marginBottom: 40,
    textAlign: "center",
    color: globalConfigurableData.primaryTextColor1,
  },
  textFontStyle: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottomWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    paddingHorizontal: 18,
    paddingVertical: 15,
  },
  tableContainer: {
    borderWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    borderRadius: 10,
    //paddingHorizontal: 18,
    marginBottom: 45,
  },
  failedOrderText: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.tertiaryTextColor1,

    textAlign: "center",
  },
});
